import styled from 'styled-components';
import {Link} from 'react-router-dom';


export const View = styled.div``;

export const Container = styled.div`
min-height: 692px;
position: fixed;
bottom: 0;
left: 0;
right: 0;
top: 0;
z-index: 0;
overflow: hidden;
background: linear-gradient(
  108deg,
  rgba(246, 246, 246, 1) 0%,
  rgba(246, 246, 246, 1) 100%
);
`;

export const FormWrap = styled.div`
height: 100%;
display: flex;
flex-direction: column;
justify-content: center;

@media screen and (max-width: 400px ) {
  height: 80%;
}
`;

export const Icon = styled(Link)`
align-self: center;
margin-top: 40px;
text-decoration: none;
color: #fff;
font-weight: 700;
font-size: 20px;
transition: all 0.2s ease-in-out;

&:hover{
  transform: scale(1.02);
  transition: all 0.2 ease-in-out;

@media screen and (max-width: 480px) {
  margin-left: 16px;
  margin-top: 8px;
}
`;

export const LogoSL = styled.img`
height: 100px;
width: 220px;
`;

export const FormContent = styled.div`
height: 100%;
display: flex;
flex-direction: column;
justify-content: center;

@media screen and (max-width: 480px) {
  padding: 10px;
}
`;

export const Form = styled.form`
background: blue;
max-width: 400px;
height: auto;
width: 100%;
z-index: 1;
display: grid;
margin: 0 auto;
margin-bottom: 100px;
padding: 50px 32px;
border-radius: 4px;
box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);

@media screen and (max-width: 400px) {
  padding: 32px 32px;
}
`;

export const TitleTopBar = styled.h3``;

export const FormLabel = styled.label`
margin-bottom: 8px;
font-size: 14px;
color: #fff;
`;

export const FormInput = styled.input`
padding: 16px 16px;
margin-left: 32px;
border: none;
border-radius: 4px;
background: 'rgba(238, 238, 238, 0.9)',
height: 100%;
width: 30%;

`;

export const FormInputColumn = styled.input`
padding: 8px 16px;
border: none;
border-radius: 4px;
background: 'rgba(238, 238, 238, 0.1)',
height: 20%;
width: 90%;

`;

export const FormInputColumn2 = styled.input`
padding: 16px 16px;
margin-top: 5px;
border: none;
border-radius: 4px;
background: 'rgba(238, 238, 238, 0.9)',
height: 100%;
width: 90%;

`;

export const FormButton = styled.button`
background: linear-gradient(
  108deg,
  rgba(13, 75, 150, 1) 0%,
  rgba(73, 77, 83, 1) 100%
);
padding: 16px 0;
border: none;
border-radius: 4px;
color: #fff;
font-size: 20px;
cursor: pointer;
`;

export const Text = styled.button`
background: none;
border: none;
cursor: pointer;
text-align: center;
margin-top: 24px;
color: #fff;
font-size: 14px;

`